export default __webpack_public_path__ + "static/media/480_store03-es-mobile.e78a26c3.png";